var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
import { request } from '@max/meituan-uni-network';
import { AntiReqTool } from '@nibfe/h5guard-request';
// import mockData from './aiAssistant_mock';
const isWeb = true;
const baseURL = 'https://ihotel.meituan.com';
// const baseURL = 'https://api.hotel.test.meituan.com';
export const fetchAiAssistantData = (params, ctx) => __awaiter(void 0, void 0, void 0, function* () {
    // const delay = (ms: number) => new Promise(resolve => setTimeout(resolve, ms));
    // await delay(1000);
    // return mockData;
    const isPtest = false; // NOTE:important ptest环境测试，上线前需置为false
    let url = `${baseURL}/landing/page/decisionText/queryAIAssistantDecisionText`;
    let finalData = params;
    if (true) {
        try {
            const antiReq = new AntiReqTool({
                autoFillParams: true
            });
            // @ts-ignore
            finalData = antiReq.addCommonParams(finalData);
        }
        catch (e) {
            console.warn('添加反爬参数失败', e);
            // reportJSInfo({ level: 'info', content: '请求加上反爬参数错误', secCategory: 'ajaxError' });
        }
    }
    const newPromise = new Promise((resolve, reject) => {
        request({
            url,
            data: Object.assign({}, finalData),
            method: 'POST',
            header: {
                'content-type': 'application/json'
                // 'swimlane': 'xuekaiyang-tszwz' // NOTE:important 泳道环境测试，上线前需注释掉
            },
            _meituan: {
                requestType: 'MRNUtils',
                mrnChannel: 'hotel',
                params: finalData
            },
            success(res) {
                var _a, _b, _c;
                if (((_a = res === null || res === void 0 ? void 0 : res.data) === null || _a === void 0 ? void 0 : _a.status) === 0) {
                    resolve((_c = (_b = res === null || res === void 0 ? void 0 : res.data) === null || _b === void 0 ? void 0 : _b.data) !== null && _c !== void 0 ? _c : {});
                }
                else {
                    resolve({});
                }
            },
            fail(e) {
                console.warn('网络开小差了');
                ctx === null || ctx === void 0 ? void 0 : ctx._raptorReport.reportLog('ai推荐接口获取失败', e, {
                    category: 'ajaxError',
                    level: 'info'
                });
                resolve({});
            }
        });
    });
    return newPromise;
});
